import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateDisputePage } from './create-dispute.page';

const routes: Routes = [
  {
    path: '',
    component: CreateDisputePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateDisputePageRoutingModule {}
